export default "__VITE_ASSET__Bx_cWiVj__"